import { defineComponent as n, computed as c, openBlock as r, createBlock as p, unref as s } from "vue";
import f from "../assets/icons/close-circle-fill.svg.mjs";
const u = /* @__PURE__ */ n({
  __name: "close-circle-fill-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(l) {
    const e = l, i = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, o = c(() => i[e.size]);
    return (t, a) => (r(), p(s(f), {
      fill: t.fill,
      width: o.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=close-circle-fill-icon.vue.mjs.map
